export const Validator = {
  validateFormat: (value, regexp) => {
    return !!value.match(regexp);
  }
}